var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Receive List",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "1000px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pb20"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.dataListLoading,
      expression: "dataListLoading"
    }],
    staticClass: "wdb100",
    attrs: {
      "border": "",
      "data": _vm.dataList,
      "size": "small",
      "max-height": "80vh"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "email",
      "align": "center",
      "label": "Email",
      "width": "260"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "clientCodeInfo.clientCode",
      "align": "center",
      "label": "Client Code",
      "width": "130"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "clientCodeInfo.uen",
      "align": "center",
      "label": "UEN",
      "width": "130"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "clientCodeInfo.companyName",
      "align": "center",
      "label": "Company Name"
    }
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "120",
      "fixed": "right",
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('el-button', {
          staticClass: "fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.detailViewHandle(scope.row);
            }
          }
        }, [_vm._v("Detail")])];
      }
    }])
  })], 1)], 1)]), _c('receive-detail', {
    ref: "receiveDetail"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }